import {
  Space,
  Dropdown,
  message
} from "antd";
import React, {
  forwardRef,
  useEffect,
  useState,
  useRef,
} from "react";
import {
  EditOutlined,
  MenuOutlined,
  HistoryOutlined
} from "@ant-design/icons";
import { useLocation } from 'react-router-dom';
import http from "@/utils/http";
import api from "@/utils/api";
import ViewLoanModal from "./component/ViewLoanModal";
import UploadTenantModal from "./component/UploadTenantModal";
import commonFn from "@/utils/commonFn";
import { CustomTable, CustomTableExtend, CustomModal } from "@/hocComponents";

const MainTable = forwardRef((props, ref) => {
  const initTableHead = {
    // entityStr: null,
    // propCount: null,
    // monthlyPayment: null,
    // achAccount: null,
    // currentLoan: null,
    // originalLoan: null,
    // Lender: null,
    // interestRate: null,
    // loanDate: null,
    // loanEndDateStr: null,
    // termPeriod: null,
    // variableIndex: null,
    // marginRate: null,
    // loanType: null,
    // recourse: null,
    prop: null,
    addressCityStateZip: null,
    propType: null,
    units: null,
    lender: null,
    loanNumber: null,
    liabilityGlAcct: null,
    expenseGlAcct: null,
    loanBalance: null,
    paidOffDate: null,
  }
  const location = useLocation();
  const [tableHead, setTableHead] = useState(initTableHead);

  const tableFilterFn = (event, key, type = 'Input') => {
    commonFn.tableFilterFn({event, key, type, setTableHead, getTableListFn, pageSize: 100})
  }

  const initColumns = [
    // {
    //   dataIndex: '#'
    // },
    {
      title: "Action",
      key: "action",
      dataIndex: "",
      hidden: false,
      align: "center",
      width: 80,
      render: (text, record, index) => (
        (commonFn.btnAuthorityFlag("Edit")) && (<Dropdown
          menu={{
            items: [
              {
                key: "edit",
                icon: <EditOutlined style={{ color: "#00c0ef", fontSize: "17px" }} />,
                label: <div>Edit</div>,
              }
            ],
            onClick: (e) => handleMenuClick(e, record),
          }} 
          trigger={["click"]}
        >
          <MenuOutlined className="col-blue" />
        </Dropdown>
        )) || null
    },
    {
      title: 'Prop#',
      dataIndex: "prop",
      titleType: 'Input',
      isSorter: true,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'prop')
    },
    {
      title: 'Address City State Zip',
      dataIndex: "addressCityStateZip",
      titleType: 'Input',
      isSorter: true,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'addressCityStateZip')
    },
    {
      title: 'Prop Type',
      dataIndex: "propType",
      titleType: 'Input',
      isSorter: true,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'propType')
    },
    {
      title: 'Units',
      dataIndex: "units",
      titleType: '',
    },
    {
      title: 'Lender',
      dataIndex: "lender",
      titleType: '',
    },
    {
      title: 'Loan Number',
      dataIndex: "loanNumber",
      titleType: '',
    },
    {
      title: 'Liability GL',
      dataIndex: "liabilityGlAcct",
      titleType: 'Input',
      isSorter: true,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'liabilityGlAcct')
    },
    {
      title: 'Expense GL',
      dataIndex: "expenseGlAcct",
      titleType: 'Input',
      isSorter: true,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'expenseGlAcct')
    },
    {
      title: "Loan Balance",
      dataIndex: "loanBalance",
      titleType: "",
      isAmountFlag: true,
    },
    {
      title: 'Payoff Date',
      dataIndex: "paidOffDate",
      titleType: 'DatePicker',
      isSorter: false,
      format: 'MM/DD/YYYY',
      onChange: (e) => tableFilterFn(e, 'paidOffDate', 'DatePickerFormat'),
    },
    {
      title: 'Ratio',
      dataIndex: "loanRatio",
      titleType: 'Input',
      isSorter: true,
      isPercent: true,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'loanRatio')
    },
    // {
    //   title: 'Monthly',
    //   dataIndex: "monthlyFee",
    //   titleType: '',
    //   isSorter: true,
    //   sortterMultiple: 3,
    // },
    // {
    //   title: "Current Loan",
    //   dataIndex: "currentLoan",
    //   titleType: "Input",
    //   width: 100,
    //   isSorter: true,
    //   sortterMultiple: 3,
    //   isAmountFlag: true,
    //   onChange: (e) => tableFilterFn(e, "currentLoan"),
    // },
    // {
    //   title: "Original Loan",
    //   dataIndex: "originalLoan",
    //   titleType: "Input",
    //   width: 100,
    //   isSorter: true,
    //   sortterMultiple: 3,
    //   isAmountFlag: true,
    //   onChange: (e) => tableFilterFn(e, "originalLoan"),
    // },
    // {
    //   title: "Allocation",
    //   dataIndex: "allocation",
    //   titleType: "Input",
    //   width: 100,
    //   isSorter: true,
    //   sortterMultiple: 3,
    //   isAmountFlag: true,
    //   onChange: (e) => tableFilterFn(e, "allocation"),
    // },

    // {
    //   title: 'Sold Date',
    //   dataIndex: "soldDate",
    //   titleType: 'DatePicker',
    //   isSorter: false,
    //   format: 'MM/DD/YYYY',
    //   onChange: (e) => tableFilterFn(e, 'soldDate', 'DatePicker'),
    // },
  ]

  const [columns, setColumns] = useState(initColumns);
  const [month6Columns, setMonth6Columns] = useState([]);
  const [refreshKey, setRefreshKey] = useState(0);
  const [tableList, setTableList] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 100,
    total: 0,
  });

  //列表
  const getTableListFn = async (current, pageSize, tableHead = {}) => {
    setTableLoading(true);
    const params = {
      page: current || pagination.current,
      count: pageSize || pagination.pageSize,
      ...tableHead,
      rollId: new URLSearchParams(location.search).get('rollId')
    };
    const response = await http.post(api.getRollingSubList, params);
    if(!response) return
    if(response && response?.code !== "1") {
      commonFn.modalFailedFn(response)
      setTableLoading(false);
      return
    }
    const list = (response.data.list || []).map((item, index) => ({ ...item, '#': (params.page - 1) * params.count + index + 1}));
    setTableList(list);
    setPagination((prev) => ({
      ...prev,
      total: response.data.total || 0,
      current: params.page,
      pageSize: params.count,
    }));
    setTableLoading(false);
  };

  const handleTableChange = (pagination, filters, sorter) => {
    getTableListFn(pagination.current, pagination.pageSize, tableHead);
  };

  // 新增修改
  const ViewLoanRef = useRef(null);
  
  const newFn = () => {
    ViewLoanRef.current.openModal({
      rollId: new URLSearchParams(location.search).get('rollId'),
      type: 'add',
      modalName: 'New',
    })
  }

  const handleMenuClick = async (item, record) => {
    const { key } = item
    if(['edit'].includes(key)){
      ViewLoanRef.current.openModal({
        id: record.id,
        rollId: new URLSearchParams(location.search).get('rollId'),
        type: 'edit',
        modalName: 'Edit Mortgage',
      })
    }
  }

  const [selectedList, setSelectedList] = useState([]);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [approvalLoading, setApprovalLoading] = useState(false);

  const customModalRef = useRef(null);

  const deleteFn = async () => {
    setDeleteLoading(true)
    const response = await http.get(api.delRollingSub, {
      params: {
        ids: String(selectedList.map(item => item.id))
      },
    });
    if (response.code === "1") {
      message.success("Successfully delete.");
      getTableListFn(pagination.current, pagination.pageSize, tableHead);
    } else {
      commonFn.modalFailedFn(response);
    }
    setDeleteLoading(false)
  };

  const initColunmsFn = () => {
    setPagination({
      current: 1,
      pageSize: 100,
      total: 0,
    })
    setDeleteLoading(false)
    setTableList([])
    setTableHead(initTableHead);
    setColumns([...initColumns, ...month6Columns]);
  }

  const submitInitFn = () => {
    initColunmsFn()
    getTableListFn(pagination.current, pagination.pageSize, tableHead);
  }

  const month6ColumnsFn = async () => {
    const response = await http.get(api.mortgageTitle);
    if(response?.code === "1"){
      const month6Columns = (response?.data || [])?.map((month) => ({
        title: month,
        dataIndex: month,
        key: month,
        width: 100,
        onCell: () => ({className: 'cellAmount'}),
        render: (text, record) => {
          const result = record?.map?.[month] || null;
          return result?.repayment ? (<span
            style={{
              color: result?.colorStr || "#1890ff",
            }}
          >
            {commonFn.amountToDollarFn(result?.repayment)}
          </span>) : null
        },
      }));
      setMonth6Columns(month6Columns)
    }
  };

  useEffect(() => {
    month6ColumnsFn();
  }, [])

  useEffect(() => {
    if(month6Columns?.length){
      setColumns([...initColumns, ...month6Columns]);
    }
  }, [month6Columns])

  useEffect(() => {
    initColunmsFn()
    getTableListFn(1, 100)
  }, [refreshKey])

  const UploadTenantRef = useRef(null);

  const uploadTenantFn = () => {
    UploadTenantRef.current.openModal({
      downloadList: [
        {
          iconKey: 'docIcon',
          text: 'Click Here for File Format instruction',
          desc: 'Upload allows users to add single and multiple For the CSV file formatting instructions please click link below',
          downloadState: {
            url: api.mortgageDownload,
            params: {type: 3},
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            suffix: 'docx',
            name: `Mortgage-Upload-Instruction`
          }
        },
        {
          iconKey: 'csvIcon',
          text: 'Click Here for sample File',
          desc: 'To Use Upload,Please Drag & Drop a csv File',
          downloadState: {
            url: api.mortgageDownload,
            params: {type: 4},
            type: 'text/csv;charset=utf-8;',
            suffix: 'csv',
            name: `Mortgage-Upload-Sample`
          }
        }
      ],
      uploadFileState: {
        url: api.importSubExcel,
        params: {
          rollId: new URLSearchParams(location.search).get('rollId')
        }
      }
    })
  }

  const approvalFn = async() => {
    setApprovalLoading(true)
    const rollId = new URLSearchParams(location.search).get('rollId')
    const response = await http.get(api.mortgageApprovalFlag, {params: {rollId }});
    if (response.code === "1") {
      const res = await http.get(api.mortgageApproval, {params: {rollId}});
      if (res.code === "1") {
        setApprovalLoading(false)
        message.success("Send For Approval Summary Successfully.");
        getTableListFn(pagination.current, pagination.pageSize, tableHead);
      } else {
        setApprovalLoading(false)
        commonFn.modalFailedFn(res)
      }
    } else {
      setApprovalLoading(false)
      commonFn.modalFailedFn(response)
    }
  }

  return (
    <div>
      <CustomTableExtend
        columns={columns}
        setColumns={setColumns}
        initColumns={initColumns}
        refreshKey={refreshKey}
        setRefreshKey={setRefreshKey}
        noShowList={[!commonFn.btnAuthorityFlag('Download') && 'download']}
      >
        <div className="topLeft">
          {(commonFn.btnAuthorityFlag("New") && (
            <Space size="large">
                {commonFn.btnDocFn({ btnFn: newFn },{
                  imageStyle: { filter: "brightness(0) invert(1)" }
                })}
            </Space>
          )) || null}
          {(commonFn.btnAuthorityFlag("Delete") && (
            <Space size="large">
                {commonFn.btnDocFn({ name: 'Delete', btnFn: () => {
                  if(!selectedList?.length){
                    message.warning("Please select at least one item.");
                  } else {
                    customModalRef.current.openModalFn()
                  }
                },loading: deleteLoading},{
                  iconKey: 'deleteIcon',
                  imageStyle: { filter: "brightness(0) invert(1)" }
                })}
            </Space>
          )) || null}
          {(commonFn.btnAuthorityFlag("UploadCSV") && (
            <Space size="large">
                {commonFn.btnDocFn({ name: 'Upload', btnFn: uploadTenantFn },{
                  iconKey: 'uploadIcon',
                  imageStyle: { filter: "brightness(0) invert(1)" }
                })}
            </Space>
          )) || null}
          {(commonFn.btnAuthorityFlag("Approval") && (
            <Space size="large">
                {commonFn.btnDocFn({ name: 'Send For Approval Summary', btnFn: approvalFn,loading: approvalLoading },{
                  iconKey: 'approval',
                  imageStyle: { filter: "brightness(0) invert(1)" }
                })}
            </Space>
          )) || null}
        </div>
      </CustomTableExtend>

      <CustomTable 
        refreshKey={refreshKey}
        tableLoading={tableLoading}
        rowSelection={{
          preserveSelectedRowKeys: true,
          type: "checkbox",
          selectedRowKeys: selectedList.map(item => item.id),
          onChange: (selectedRowKeys, selectedRows) => {
            setSelectedList(selectedRows);
          },
        }}
        rowKey="id"
        columns={columns}
        tableList={tableList}
        pagination={pagination}
        handleTableChange={handleTableChange}
        tableScrollY="350px"
      />

      <ViewLoanModal
        ref={ViewLoanRef}
        submitInitFn={submitInitFn}
      />

      <CustomModal
        ref={customModalRef}
        customConfig={{
          width: 500,
          content: 'Are you sure to delete selected data?',
          onOkFn: deleteFn,
        }}
      />

      <UploadTenantModal
        ref={UploadTenantRef}
        submitInitFn={submitInitFn}
      />
    </div>
  );
});
export default MainTable;
